<div class="dashboard-content branding-screen" style="padding: 120px 40px 50px">
  <!-- Page Heading -->
  <div class="page-heading">
    <h3>
      <i class="fa-solid fa-palette" style="color: #5304fb; margin-right: 8px;"></i>
      {{ 'branding.title' | translate }}
    </h3>
  </div>

  <!-- Custom Luqta Tabs & Actions -->
  <div class="custom-tabs-container mb-4">
    <div class="custom-tabs-header d-flex justify-content-between align-items-center">
      <ul class="custom-nav-tabs" role="tablist">
        <li class="nav-item">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'brands'"
            [attr.aria-selected]="activeTab === 'brands'" (click)="selectTab('brands')">
            {{ 'branding.brands-list' | translate }} ({{ brands.length }})
          </button>
        </li>
        <li class="nav-item">
          <button type="button" class="nav-link" role="tab" [class.active]="activeTab === 'domains'"
            [attr.aria-selected]="activeTab === 'domains'" (click)="selectTab('domains')">
            {{ 'branding.domains-hosts' | translate }} ({{ domains.length }})
          </button>
        </li>
      </ul>

      <div class="d-flex align-items-center gap-2 flex-wrap">
        <button class="btn action-btn-secondary" (click)="openExampleJsonModal()" [title]="'branding.example-json-tooltip' | translate">
          <i class="fa-solid fa-file-code me-2"></i>
          <span>{{ 'branding.example-json' | translate }}</span>
        </button>
        <button class="btn action-btn-secondary" (click)="openImportJsonModal()" [title]="'branding.import-json-tooltip' | translate">
          <i class="fa-solid fa-file-import me-2"></i>
          <span>{{ 'branding.import-json' | translate }}</span>
        </button>
        <button class="btn btn-primary action-btn-purple" (click)="openCreateDomainModal()">
          <i class="fa-solid fa-globe me-2"></i>
          <span>{{ 'branding.add-domain' | translate }}</span>
        </button>
        <button class="btn btn-primary action-btn-purple" (click)="openCreateBrandModal()">
          <i class="fa-solid fa-plus me-2"></i>
          <span>{{ 'branding.create-brand' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="luqta-card text-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- BRANDS TAB -->
  <div *ngIf="!isLoading && activeTab === 'brands'">
    <div *ngIf="brands.length === 0" class="luqta-card empty-state-card text-center py-5">
      <div class="empty-icon-circle mx-auto mb-3">
        <i class="fa-solid fa-palette"></i>
      </div>
      <h4 class="empty-title">{{ 'branding.no-brands' | translate }}</h4>
      <p class="empty-subtitle">
        {{ 'branding.no-brands-desc' | translate }}
      </p>
    </div>

    <div *ngIf="brands.length > 0" class="row g-4">
      <div *ngFor="let brand of brands" class="col-12 col-md-6 col-lg-4">
        <div class="luqta-card brand-card-box h-100 d-flex flex-column justify-content-between">
          <div>
            <div class="brand-card-header d-flex justify-content-between align-items-start mb-3">
              <div class="d-flex align-items-center gap-3">
                <div class="brand-avatar-box" [style.backgroundColor]="getBrandAvatarLogo(brand) ? '#ffffff' : getBrandThemeColor(brand, 'primary')">
                  <img *ngIf="getBrandAvatarLogo(brand)" [src]="getBrandAvatarLogo(brand)" alt="Logo" class="brand-card-logo-img" />
                  <span *ngIf="!getBrandAvatarLogo(brand)">{{ (brand.name || brand.display_name || 'B').charAt(0).toUpperCase() }}</span>
                </div>
                <div>
                  <h4 class="brand-title m-0">
                    {{ brand.name || brand.display_name || 'Brand Name' }}
                    <span *ngIf="brand.is_default" class="badge bg-amber-soft text-amber ms-1">Default</span>
                  </h4>
                  <div *ngIf="brand.display_name && brand.display_name !== brand.name" class="font-12 fw-medium text-primary mt-0.5">
                    {{ brand.display_name }}
                    <span *ngIf="brand.brand?.identity?.display_name_ar" class="text-muted ms-1" dir="rtl">({{ brand.brand?.identity?.display_name_ar }})</span>
                  </div>
                  <div *ngIf="brand.brand?.identity?.tagline" class="text-muted font-11 mt-0.5">
                    <i class="fa-solid fa-quote-left text-xs me-1 text-muted opacity-50"></i>{{ brand.brand?.identity?.tagline }}
                  </div>
                  <small class="text-muted d-block mt-0.5">{{ brand.description || brand.brand?.meta?.description || 'No description' }}</small>
                </div>
              </div>
              <span class="status-badge" [class.active]="brand.is_active" [class.inactive]="!brand.is_active">
                {{ brand.is_default ? 'Default' : (brand.is_active ? 'Active' : 'Inactive') }}
              </span>
            </div>

            <div class="swatches-section mb-3">
              <label class="section-label">{{ 'branding.theme-color-palette' | translate }}</label>
              <div class="d-flex align-items-center gap-2 mt-1">
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'primary')"
                  nz-tooltip [nzTooltipTitle]="('branding.primary-color' | translate) + ': ' + getBrandThemeColor(brand, 'primary')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'secondary')"
                  nz-tooltip [nzTooltipTitle]="('branding.secondary-color' | translate) + ': ' + getBrandThemeColor(brand, 'secondary')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'accent')"
                  nz-tooltip [nzTooltipTitle]="('branding.accent-color' | translate) + ': ' + getBrandThemeColor(brand, 'accent')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'heading')"
                  nz-tooltip [nzTooltipTitle]="('branding.heading-color' | translate) + ': ' + getBrandThemeColor(brand, 'heading')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'bg')"
                  nz-tooltip [nzTooltipTitle]="('branding.bg-color' | translate) + ': ' + getBrandThemeColor(brand, 'bg')"></div>
                <div class="swatch-item" [style.backgroundColor]="getBrandThemeColor(brand, 'surface')"
                  nz-tooltip [nzTooltipTitle]="('branding.surface-color' | translate) + ': ' + getBrandThemeColor(brand, 'surface')"></div>
              </div>
            </div>

            <div class="domains-section mb-3">
              <label class="section-label">{{ 'branding.domains-hosts' | translate }}</label>
              <div class="d-flex flex-wrap gap-1 mt-1">
                <ng-container *ngFor="let dom of getBrandDomains(brand.id)">
                  <span class="domain-tag font-mono">{{ dom.hostname }}</span>
                </ng-container>
                <span *ngIf="!hasBrandDomains(brand.id)" class="text-muted fst-italic text-xs">No domain attached</span>
              </div>
            </div>
          </div>

          <div class="brand-card-footer pt-3 border-top d-flex align-items-center justify-content-between">
            <button (click)="openEditBrandModal(brand)" class="btn btn-link p-0 edit-brand-btn">
              <i class="fa-solid fa-pen-to-square me-1"></i> {{ 'branding.edit' | translate }}
            </button>
            <div class="d-flex align-items-center gap-2">
              <button *ngIf="!brand.is_default" (click)="setDefaultBrand(brand)" class="btn btn-light btn-sm font-12">
                Make Default
              </button>
              <button (click)="openCreateDomainModal(brand.id)" class="btn btn-outline-primary btn-sm font-12">
                <i class="fa-solid fa-plus me-1"></i>{{ 'branding.add-domain' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- DOMAINS TAB -->
  <div *ngIf="!isLoading && activeTab === 'domains'">
    <div class="luqta-card">
      <div class="card-heading mb-3">
        <div>
          <h3 class="m-0">{{ 'branding.domains-hosts' | translate }} ({{ domains.length }})</h3>
          <p class="card-subtitle">{{ 'branding.subtitle' | translate }}</p>
        </div>
      </div>

      <nz-table #domainsTable [nzData]="domains" [nzBordered]="false" [nzScroll]="{ x: '1000px' }"
        [nzPageSize]="10" [nzShowSizeChanger]="false" class="domains-table">
        <thead>
          <tr>
            <th>{{ 'branding.domain-name' | translate }}</th>
            <th>{{ 'branding.brand' | translate }}</th>
            <th>{{ 'branding.type' | translate }}</th>
            <th>{{ 'branding.zero-storage' | translate }}</th>
            <th>{{ 'branding.status' | translate }}</th>
            <th nzWidth="360px" class="text-end">{{ 'branding.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dom of domainsTable.data">
            <td>
              <div class="domain-identity">
                <span class="domain-hostname">{{ dom.hostname }}</span>
                <span *ngIf="dom.is_primary" class="domain-primary">{{ 'branding.primary-domain' | translate }}</span>
              </div>
            </td>
            <td>{{ getBrandName(dom.branding_id) }}</td>
            <td>{{ (dom.kind === 'subdomain' ? 'branding.subdomain' : 'branding.custom-domain') | translate }}</td>
            <!--
              The hint identifies which key is on the host without being one —
              eight hex characters of a hash. The key itself is never returned
              by domain/list and is never shown here.
            -->
            <td>
              <ng-container *ngIf="dom.zero_storage; else standardStorage">
                <span class="zero-storage-badge">
                  <i class="fa-solid fa-lock" aria-hidden="true"></i>{{ 'branding.zero-storage-on' | translate }}
                </span>
                <div *ngIf="dom.zero_storage_key_hint" class="text-muted font-mono font-12 mt-1">
                  {{ 'branding.zero-storage-key-hint-label' | translate }}: {{ dom.zero_storage_key_hint }}
                </div>
              </ng-container>
              <ng-template #standardStorage>
                <span class="text-muted">{{ 'branding.standard-storage' | translate }}</span>
              </ng-template>
            </td>
            <td>
              <span class="status-badge" [class.active]="domainStatus(dom) === 'live'"
                [class.expired]="domainStatus(dom) !== 'live'">
                {{ (domainStatus(dom) === 'live' ? 'branding.domain-live' : (domainStatus(dom) === 'failed' ? 'branding.domain-failed' : 'branding.domain-pending')) | translate }}
              </span>
            </td>
            <td class="text-end">
              <div class="domain-actions">
                <button type="button" (click)="openEditDomainModal(dom)" class="domain-action-btn"
                  [attr.aria-label]="('branding.edit' | translate) + ': ' + dom.hostname">
                  <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                  {{ 'branding.edit' | translate }}
                </button>
                <!--
                <button type="button" *ngIf="dom.dns_setup" (click)="showDnsSetup(dom)"
                  class="domain-action-btn domain-action-btn--secondary">
                  <i class="fa-solid fa-list" aria-hidden="true"></i>
                  {{ 'branding.view-dns' | translate }}
                </button>
                -->
                <button type="button" *ngIf="domainStatus(dom) !== 'live'" (click)="verifyDomain(dom)"
                  [disabled]="verifyingDomainId === dom.id" class="domain-action-btn">
                  <i class="fa-solid fa-check" aria-hidden="true"></i>
                  {{ verifyingDomainId === dom.id ? 'Checking...' : 'Verify DNS' }}
                </button>
                <!--
                <button type="button" *ngIf="dom.status !== 'live'" (click)="deleteDomain(dom)"
                  class="domain-action-btn domain-action-btn--danger">
                  <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
                  {{ 'branding.delete' | translate }}
                </button>
                -->
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>

<!-- BRAND MODAL (Create & Edit) -->
<nz-modal [(nzVisible)]="isBrandModalVisible" [nzCentered]="true"
  [nzTitle]="modalHeaderTpl"
  [nzFooter]="modalFooterTpl"
  (nzOnCancel)="isBrandModalVisible = false"
  [nzWidth]="880" nzClassName="luqta-styled-modal brand-customizer-modal">
  
  <ng-template #modalHeaderTpl>
    <div class="brand-modal-header-content">
      <div class="d-flex align-items-center gap-3">
        <div class="modal-header-icon-circle">
          <i class="fa-solid fa-palette"></i>
        </div>
        <div>
          <h4 class="m-0 fw-bold text-dark font-18">{{ editingBrand ? ('branding.edit-brand-modal-title' | translate) : ('branding.create-brand-modal-title' | translate) }}</h4>
          <p class="text-muted font-12 m-0">{{ 'branding.subtitle' | translate }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <form [formGroup]="brandForm" class="brand-customizer-form">

      <!-- JSON Quick Action Bar -->
      <div class="brand-json-quick-bar mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="json-bar-icon">
            <i class="fa-solid fa-code"></i>
          </div>
          <div>
            <div class="json-bar-title">JSON Configuration</div>
            <div class="json-bar-desc">Directly edit raw brand schema or import a JSON file.</div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn-json-action edit" (click)="openEditJsonFromForm()">
            <i class="fa-solid fa-code"></i>
            <span>{{ 'branding.edit-json' | translate }}</span>
          </button>
          <button type="button" class="btn-json-action upload" (click)="openUploadJsonFromForm()">
            <i class="fa-solid fa-cloud-arrow-up"></i>
            <span>{{ 'branding.upload-json' | translate }}</span>
          </button>
        </div>
      </div>
      
      <!-- Section 1: Basic Information -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">1</span>
          <span class="section-title">General Information</span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.brand-name' | translate }} <span class="text-danger">*</span></label>
            <div class="input-with-icon">
              <i class="fa-solid fa-tag input-lead-icon"></i>
              <input formControlName="name" type="text" [placeholder]="'branding.brand-name-placeholder' | translate" class="form-control ps-5"
                [class.is-invalid]="brandForm.controls['name'].invalid && brandForm.controls['name'].touched" />
            </div>
            <ng-container *ngIf="brandForm.controls['name'].invalid && brandForm.controls['name'].touched">
              <div class="text-danger font-12 mt-1" *ngIf="brandForm.controls['name'].hasError('maxlength'); else nameRequired">
                {{ 'branding.name-too-long' | translate }}
              </div>
              <ng-template #nameRequired>
                <div class="text-danger font-12 mt-1">{{ 'branding.name-required' | translate }}</div>
              </ng-template>
            </ng-container>
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.description' | translate }}</label>
            <div class="input-with-icon">
              <i class="fa-solid fa-align-left input-lead-icon"></i>
              <input formControlName="description" type="text" [placeholder]="'branding.description-placeholder' | translate" class="form-control ps-5" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check">
              <input formControlName="is_active" type="checkbox" id="brand_is_active" class="form-check-input" />
              <label for="brand_is_active" class="form-check-label font-13 text-secondary">Active</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check">
              <input formControlName="is_default" type="checkbox" id="brand_is_default" class="form-check-input" />
              <label for="brand_is_default" class="form-check-label font-13 text-secondary">Use as default brand</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Colors & Real-Time Preview -->
      <div class="form-section-card mb-4">
        <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <div class="section-header m-0">
            <span class="section-step-badge">2</span>
            <span class="section-title">{{ 'branding.theme-color-palette' | translate }}</span>
          </div>
          <div class="theme-mode-toggle">
            <button type="button" (click)="colorThemeTab = 'light'" class="toggle-mode-btn" [class.active]="colorThemeTab === 'light'">
              <i class="fa-solid fa-sun me-1"></i> {{ 'branding.light-mode' | translate }}
            </button>
            <button type="button" (click)="colorThemeTab = 'dark'" class="toggle-mode-btn" [class.active]="colorThemeTab === 'dark'">
              <i class="fa-solid fa-moon me-1"></i> {{ 'branding.dark-mode' | translate }}
            </button>
          </div>
        </div>

        <div class="row g-4 align-items-center">
          <!-- Left: Color Swatch Inputs (2 Columns) -->
          <div class="col-12 col-md-7">
            <!-- Light Mode Colors -->
            <div *ngIf="colorThemeTab === 'light'" class="color-swatches-grid">
              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.primary-color' | translate }} <span class="text-danger">*</span></label>
                <div class="color-input-wrapper">
                  <input formControlName="primary_color" type="color" class="color-picker-native" (input)="onColorPick('primary_color', $event)" />
                  <input formControlName="primary_color" (input)="onColorHexInput('primary_color', $event)" (blur)="onColorHexBlur('primary_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.secondary-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="secondary_color" type="color" class="color-picker-native" (input)="onColorPick('secondary_color', $event)" />
                  <input formControlName="secondary_color" (input)="onColorHexInput('secondary_color', $event)" (blur)="onColorHexBlur('secondary_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.accent-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="accent_color" type="color" class="color-picker-native" (input)="onColorPick('accent_color', $event)" />
                  <input formControlName="accent_color" (input)="onColorHexInput('accent_color', $event)" (blur)="onColorHexBlur('accent_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.heading-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="heading_color" type="color" class="color-picker-native" (input)="onColorPick('heading_color', $event)" />
                  <input formControlName="heading_color" (input)="onColorHexInput('heading_color', $event)" (blur)="onColorHexBlur('heading_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.bg-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="bg_color" type="color" class="color-picker-native" (input)="onColorPick('bg_color', $event)" />
                  <input formControlName="bg_color" (input)="onColorHexInput('bg_color', $event)" (blur)="onColorHexBlur('bg_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.surface-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="surface_color" type="color" class="color-picker-native" (input)="onColorPick('surface_color', $event)" />
                  <input formControlName="surface_color" (input)="onColorHexInput('surface_color', $event)" (blur)="onColorHexBlur('surface_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Body Text</label>
                <div class="color-input-wrapper">
                  <input formControlName="text_color" type="color" class="color-picker-native" (input)="onColorPick('text_color', $event)" />
                  <input formControlName="text_color" (input)="onColorHexInput('text_color', $event)" (blur)="onColorHexBlur('text_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Muted Text</label>
                <div class="color-input-wrapper">
                  <input formControlName="text_muted_color" type="color" class="color-picker-native" (input)="onColorPick('text_muted_color', $event)" />
                  <input formControlName="text_muted_color" (input)="onColorHexInput('text_muted_color', $event)" (blur)="onColorHexBlur('text_muted_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Success</label>
                <div class="color-input-wrapper">
                  <input formControlName="success_color" type="color" class="color-picker-native" (input)="onColorPick('success_color', $event)" />
                  <input formControlName="success_color" (input)="onColorHexInput('success_color', $event)" (blur)="onColorHexBlur('success_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Warning</label>
                <div class="color-input-wrapper">
                  <input formControlName="warning_color" type="color" class="color-picker-native" (input)="onColorPick('warning_color', $event)" />
                  <input formControlName="warning_color" (input)="onColorHexInput('warning_color', $event)" (blur)="onColorHexBlur('warning_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Error</label>
                <div class="color-input-wrapper">
                  <input formControlName="error_color" type="color" class="color-picker-native" (input)="onColorPick('error_color', $event)" />
                  <input formControlName="error_color" (input)="onColorHexInput('error_color', $event)" (blur)="onColorHexBlur('error_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <!-- brand.colors.task (--b-task-l): the "levels" pill and the task badge circles -->
              <div class="color-swatch-box" [title]="'branding.task-color-hint' | translate">
                <label class="color-label">{{ 'branding.task-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="task_color" type="color" class="color-picker-native" (input)="onColorPick('task_color', $event)" />
                  <input formControlName="task_color" (input)="onColorHexInput('task_color', $event)" (blur)="onColorHexBlur('task_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <!-- brand.colors.completed (--b-completed-l): marks a finished task -->
              <div class="color-swatch-box" [title]="'branding.completed-color-hint' | translate">
                <label class="color-label">{{ 'branding.completed-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="completed_color" type="color" class="color-picker-native" (input)="onColorPick('completed_color', $event)" />
                  <input formControlName="completed_color" (input)="onColorHexInput('completed_color', $event)" (blur)="onColorHexBlur('completed_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.gradient-start' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="gradient_start" type="color" class="color-picker-native" (input)="onColorPick('gradient_start', $event)" />
                  <input formControlName="gradient_start" (input)="onColorHexInput('gradient_start', $event)" (blur)="onColorHexBlur('gradient_start')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.gradient-end' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="gradient_end" type="color" class="color-picker-native" (input)="onColorPick('gradient_end', $event)" />
                  <input formControlName="gradient_end" (input)="onColorHexInput('gradient_end', $event)" (blur)="onColorHexBlur('gradient_end')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>
            </div>

            <!-- Dark Mode Colors -->
            <div *ngIf="colorThemeTab === 'dark'" class="color-swatches-grid">
              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-primary-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_primary_color" type="color" class="color-picker-native" (input)="onColorPick('dark_primary_color', $event)" />
                  <input formControlName="dark_primary_color" (input)="onColorHexInput('dark_primary_color', $event)" (blur)="onColorHexBlur('dark_primary_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-secondary-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_secondary_color" type="color" class="color-picker-native" (input)="onColorPick('dark_secondary_color', $event)" />
                  <input formControlName="dark_secondary_color" (input)="onColorHexInput('dark_secondary_color', $event)" (blur)="onColorHexBlur('dark_secondary_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-accent-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_accent_color" type="color" class="color-picker-native" (input)="onColorPick('dark_accent_color', $event)" />
                  <input formControlName="dark_accent_color" (input)="onColorHexInput('dark_accent_color', $event)" (blur)="onColorHexBlur('dark_accent_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-heading-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_heading_color" type="color" class="color-picker-native" (input)="onColorPick('dark_heading_color', $event)" />
                  <input formControlName="dark_heading_color" (input)="onColorHexInput('dark_heading_color', $event)" (blur)="onColorHexBlur('dark_heading_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-bg-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_bg_color" type="color" class="color-picker-native" (input)="onColorPick('dark_bg_color', $event)" />
                  <input formControlName="dark_bg_color" (input)="onColorHexInput('dark_bg_color', $event)" (blur)="onColorHexBlur('dark_bg_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.dark-surface-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_surface_color" type="color" class="color-picker-native" (input)="onColorPick('dark_surface_color', $event)" />
                  <input formControlName="dark_surface_color" (input)="onColorHexInput('dark_surface_color', $event)" (blur)="onColorHexBlur('dark_surface_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Body Text</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_text_color" type="color" class="color-picker-native" (input)="onColorPick('dark_text_color', $event)" />
                  <input formControlName="dark_text_color" (input)="onColorHexInput('dark_text_color', $event)" (blur)="onColorHexBlur('dark_text_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Muted Text</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_text_muted_color" type="color" class="color-picker-native" (input)="onColorPick('dark_text_muted_color', $event)" />
                  <input formControlName="dark_text_muted_color" (input)="onColorHexInput('dark_text_muted_color', $event)" (blur)="onColorHexBlur('dark_text_muted_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Success</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_success_color" type="color" class="color-picker-native" (input)="onColorPick('dark_success_color', $event)" />
                  <input formControlName="dark_success_color" (input)="onColorHexInput('dark_success_color', $event)" (blur)="onColorHexBlur('dark_success_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Warning</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_warning_color" type="color" class="color-picker-native" (input)="onColorPick('dark_warning_color', $event)" />
                  <input formControlName="dark_warning_color" (input)="onColorHexInput('dark_warning_color', $event)" (blur)="onColorHexBlur('dark_warning_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">Error</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_error_color" type="color" class="color-picker-native" (input)="onColorPick('dark_error_color', $event)" />
                  <input formControlName="dark_error_color" (input)="onColorHexInput('dark_error_color', $event)" (blur)="onColorHexBlur('dark_error_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <!-- brand.colors_dark.task (--b-task-d) -->
              <div class="color-swatch-box" [title]="'branding.task-color-hint' | translate">
                <label class="color-label">{{ 'branding.task-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_task_color" type="color" class="color-picker-native" (input)="onColorPick('dark_task_color', $event)" />
                  <input formControlName="dark_task_color" (input)="onColorHexInput('dark_task_color', $event)" (blur)="onColorHexBlur('dark_task_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <!-- brand.colors_dark.completed (--b-completed-d) -->
              <div class="color-swatch-box" [title]="'branding.completed-color-hint' | translate">
                <label class="color-label">{{ 'branding.completed-color' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_completed_color" type="color" class="color-picker-native" (input)="onColorPick('dark_completed_color', $event)" />
                  <input formControlName="dark_completed_color" (input)="onColorHexInput('dark_completed_color', $event)" (blur)="onColorHexBlur('dark_completed_color')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.gradient-start' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_gradient_start" type="color" class="color-picker-native" (input)="onColorPick('dark_gradient_start', $event)" />
                  <input formControlName="dark_gradient_start" (input)="onColorHexInput('dark_gradient_start', $event)" (blur)="onColorHexBlur('dark_gradient_start')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>

              <div class="color-swatch-box">
                <label class="color-label">{{ 'branding.gradient-end' | translate }}</label>
                <div class="color-input-wrapper">
                  <input formControlName="dark_gradient_end" type="color" class="color-picker-native" (input)="onColorPick('dark_gradient_end', $event)" />
                  <input formControlName="dark_gradient_end" (input)="onColorHexInput('dark_gradient_end', $event)" (blur)="onColorHexBlur('dark_gradient_end')" type="text" class="color-hex-input" maxlength="7" />
                </div>
              </div>
            </div>
          </div>

          <!-- Right: Real-Time Mobile Preview -->
          <div class="col-12 col-md-5">
            <div class="clean-preview-wrapper">
              <div class="text-uppercase text-muted font-11 fw-bold text-center mb-2">
                <i class="fa-solid fa-mobile-screen me-1 text-primary"></i> {{ 'branding.real-time-preview' | translate }}
              </div>

              <!-- Mock phone device -->
              <div class="preview-phone mx-auto" [class.is-dark]="colorThemeTab === 'dark'">
                <div class="preview-phone-notch"></div>

                <div class="preview-phone-screen"
                  [attr.dir]="previewDir"
                  [style.fontFamily]="previewFontFamily"
                  [style.fontSize.px]="previewFontSize"
                  [style.backgroundColor]="previewPageBg">

                  <!-- Status bar -->
                  <div class="preview-status-bar"
                    [style.backgroundColor]="previewGradientStart"
                    [style.color]="previewStatusBarColor">
                    <span class="preview-status-time">9:41</span>
                    <span class="preview-status-icons">
                      <i class="fa-solid fa-signal"></i>
                      <i class="fa-solid fa-wifi"></i>
                      <i class="fa-solid fa-battery-three-quarters"></i>
                    </span>
                  </div>

                  <!-- In-app browser bar: favicon + SEO page title -->
                  <div class="preview-url-bar"
                    [style.backgroundColor]="pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331')"
                    [style.color]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')">
                    <img *ngIf="brandForm.value.icon_url" [src]="extractUrl(brandForm.value.icon_url)" alt="Favicon" class="preview-favicon" />
                    <i *ngIf="!brandForm.value.icon_url" class="fa-solid fa-globe preview-favicon-fallback"></i>
                    <span class="preview-tab-title" [title]="previewTitle">{{ previewTitle }}</span>
                    <i class="fa-solid fa-rotate-right preview-url-reload"></i>
                  </div>

                  <!-- Page body: the web app's entry screen (WhatsApp number), drawn with this brand. -->
                  <div class="preview-phone-body"
                    [style.backgroundColor]="previewPageBg"
                    [style.backgroundImage]="previewGradient">
                    <div class="preview-shell mx-auto" [style.maxWidth.px]="previewShellWidth">

                      <!-- Logo + theme / language pills -->
                      <div class="pv-topbar">
                        <img *ngIf="previewLogoUrl" [src]="previewLogoUrl" alt="Logo" class="pv-logo" />
                        <span *ngIf="!previewLogoUrl" class="pv-logo-text"
                          [style.color]="pv('heading_color', 'dark_heading_color', '#122331', '#FFFFFF')">{{ previewName }}</span>

                        <div class="pv-pills">
                          <span class="pv-pill" *ngIf="!previewThemeForced"
                            [style.color]="previewTone('grey_4')"
                            [style.backgroundColor]="'color-mix(in srgb, ' + pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331') + ' 70%, transparent)'">
                            <i class="fa-solid" [class.fa-sun]="colorThemeTab !== 'dark'" [class.fa-moon]="colorThemeTab === 'dark'"></i>
                            {{ colorThemeTab === 'dark' ? previewCopy['dark'] : previewCopy['light'] }}
                          </span>
                          <span class="pv-pill"
                            [style.color]="previewTone('grey_4')"
                            [style.backgroundColor]="'color-mix(in srgb, ' + pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331') + ' 70%, transparent)'">
                            <i class="fa-solid fa-globe"></i>
                            {{ previewCopy['otherLanguage'] }}
                          </span>
                        </div>
                      </div>

                      <div class="pv-intro">
                        <h1 class="pv-heading" [style.color]="pv('heading_color', 'dark_heading_color', '#122331', '#FFFFFF')">
                          {{ previewCopy['headingStart'] }}<span class="pv-whatsapp" [class.is-dark]="colorThemeTab === 'dark'">{{ previewCopy['whatsapp'] }}</span>{{ previewCopy['headingEnd'] }}
                        </h1>
                        <p class="pv-lede" [style.color]="previewTone('grey_4')">{{ previewCopy['intro'] }}</p>
                      </div>

                      <div class="pv-form">
                        <!-- Phone field, shown filled in so the consent and Continue button appear in their active brand colours -->
                        <div class="pv-field"
                          [style.backgroundColor]="pv('surface_color', 'dark_surface_color', '#FFFFFF', '#152331')"
                          [style.borderColor]="previewTone('grey_1')"
                          [style.borderRadius.px]="previewRadius">
                          <span class="pv-country">
                            <svg class="pv-flag" viewBox="0 0 24 18" aria-hidden="true">
                              <rect width="24" height="18" fill="#8A1538" />
                              <path fill="#FFFFFF" d="M0 0h8l3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1 3 1-3 1H0z" />
                            </svg>
                            <span class="pv-dial" dir="ltr" [style.color]="pv('text_color', 'dark_text_color', '#122331', '#CBD5E1')">+974</span>
                            <i class="fa-solid fa-caret-down pv-chevron" [style.color]="previewTone('grey_3')"></i>
                          </span>
                          <span class="pv-divider" [style.backgroundColor]="previewTone('grey_1')"></span>
                          <span class="pv-number" dir="ltr" [style.color]="pv('text_color', 'dark_text_color', '#122331', '#CBD5E1')">55123456</span>
                        </div>
                        <p class="pv-hint" [style.color]="previewTone('grey_3')">{{ previewCopy['hint'] }} <bdi dir="ltr">+974</bdi></p>

                        <!-- Consent: the web app links its own /terms and /privacy pages here -->
                        <div class="pv-consent">
                          <div class="pv-consent-row">
                            <span class="pv-check"
                              [style.backgroundColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"
                              [style.borderColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"
                              [style.color]="previewTone('on_primary')">
                              <i class="fa-solid fa-check"></i>
                            </span>
                            <span class="pv-legal" [style.color]="pv('text_color', 'dark_text_color', '#122331', '#CBD5E1')">
                              {{ previewCopy['agree'] }}
                              <span class="pv-legal-link"
                                [style.color]="pv('heading_color', 'dark_heading_color', '#122331', '#FFFFFF')"
                                [style.textDecorationColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')">{{ previewCopy['terms'] }}</span>
                              {{ previewCopy['and'] }}
                              <span class="pv-legal-link"
                                [style.color]="pv('heading_color', 'dark_heading_color', '#122331', '#FFFFFF')"
                                [style.textDecorationColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')">{{ previewCopy['privacy'] }}</span>.
                            </span>
                          </div>
                          <p class="pv-note" [style.color]="previewTone('grey_3')">{{ previewCopy['note'] }}</p>
                        </div>

                        <div class="pv-cta"
                          [style.backgroundColor]="pv('primary_color', 'dark_primary_color', '#FCBA03', '#FCBA03')"
                          [style.borderRadius.px]="previewRadius">
                          {{ previewCopy['continue'] }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="preview-home-indicator"
                    [style.backgroundColor]="pv('text_muted_color', 'dark_text_muted_color', '#6B7280', '#9CA3AF')"></div>
                </div>
              </div>

              <div class="text-center text-muted font-10 mt-2">
                {{ brandForm.value.shell_max || 400 }}px shell · {{ brandForm.value.base_size || 16 }}px base ·
                {{ previewIsArabic ? (brandForm.value.font_family_ar || 'Codec Pro') : (brandForm.value.font_family || 'Codec Pro') }}
                · {{ previewIsArabic ? 'RTL' : 'LTR' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 3: Typography & Shape -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">3</span>
          <span class="section-title">Typography & Shape</span>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.font-source' | translate }}</label>
            <nz-select formControlName="font_source" class="w-100 custom-nz-select" [nzOptionOverflowSize]="5">
              <nz-option nzValue="google" [nzLabel]="'branding.google-font' | translate"></nz-option>
              <nz-option nzValue="system" [nzLabel]="'branding.system-default' | translate"></nz-option>
            </nz-select>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.font-family' | translate }}</label>
            <input formControlName="font_family" type="text" placeholder="Inter" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Arabic Font Family</label>
            <input formControlName="font_family_ar" type="text" placeholder="Vazirmatn" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Base Font Size</label>
            <div class="input-group">
              <input formControlName="base_size" type="number" min="12" max="24" step="1" class="form-control"
                [class.is-invalid]="numberError('base_size')" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
            <div *ngIf="numberError('base_size') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.card-radius' | translate }}</label>
            <div class="input-group">
              <input formControlName="radius" type="number" min="0" max="40" step="1" class="form-control"
                [class.is-invalid]="numberError('radius')" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
            <div *ngIf="numberError('radius') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Button Radius</label>
            <div class="input-group">
              <input formControlName="button_radius" type="number" min="0" max="40" step="1" class="form-control"
                [class.is-invalid]="numberError('button_radius')" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
            <div *ngIf="numberError('button_radius') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Content Max Width</label>
            <div class="input-group">
              <input formControlName="shell_max" type="number" min="320" max="1200" step="1" class="form-control"
                [class.is-invalid]="numberError('shell_max')" />
              <span class="input-group-text font-12 bg-white">px</span>
            </div>
            <div *ngIf="numberError('shell_max') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
        </div>
      </div>

      <!-- Section 4: Display Names -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">4</span>
          <span class="section-title">Localized Identity</span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.display-name-en' | translate }}</label>
            <input formControlName="display_name" type="text" placeholder="Spica Retail" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">{{ 'branding.display-name-ar' | translate }}</label>
            <input formControlName="display_name_ar" type="text" placeholder="سبيكا" dir="rtl" class="form-control text-end" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Tagline (EN)</label>
            <input formControlName="tagline" type="text" placeholder="Scan, Play, Win" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Tagline (AR)</label>
            <input formControlName="tagline_ar" type="text" placeholder="امسح، العب، واربح" dir="rtl" class="form-control text-end" />
          </div>
        </div>
      </div>

      <!-- Section 5: SEO & Page Meta -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">5</span>
          <span class="section-title">SEO & Page Meta</span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Page Title (EN)</label>
            <input formControlName="title" type="text" placeholder="Join the campaign | Brand" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Page Title (AR)</label>
            <input formControlName="title_ar" type="text" placeholder="انضم إلى الحملة" dir="rtl" class="form-control text-end" />
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Meta Description (EN)</label>
            <textarea formControlName="meta_description" rows="2" placeholder="Short description shown in search results and link previews" class="form-control"></textarea>
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Meta Description (AR)</label>
            <textarea formControlName="meta_description_ar" rows="2" dir="rtl" class="form-control text-end"></textarea>
          </div>
        </div>
      </div>

      <!-- Section 6: Support & Contact -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">6</span>
          <span class="section-title">Support & Contact</span>
        </div>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Support Email</label>
            <input formControlName="support_email" type="email" placeholder="support@brand.com" class="form-control" />
            <div class="text-danger font-12 mt-1" *ngIf="brandForm.controls['support_email'].invalid && brandForm.controls['support_email'].touched">
              Please enter a valid email address.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Support Phone</label>
            <input formControlName="support_phone" type="text" placeholder="+249 000 000 000" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">WhatsApp</label>
            <input formControlName="support_whatsapp" type="text" placeholder="+249 000 000 000" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Website</label>
            <input formControlName="support_website" type="url" placeholder="https://brand.com" class="form-control"
              [class.is-invalid]="urlError('support_website')" />
            <div *ngIf="urlError('support_website') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
        </div>
      </div>

      <!-- Section 7: Social Links -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">7</span>
          <span class="section-title">Social Links</span>
        </div>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-x-twitter me-1"></i> X (Twitter)</label>
            <input formControlName="social_x" type="url" placeholder="https://twitter.com/brand" class="form-control"
              [class.is-invalid]="urlError('social_x')" />
            <div *ngIf="urlError('social_x') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-instagram me-1"></i> Instagram</label>
            <input formControlName="social_instagram" type="url" placeholder="https://instagram.com/brand" class="form-control"
              [class.is-invalid]="urlError('social_instagram')" />
            <div *ngIf="urlError('social_instagram') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-youtube me-1"></i> YouTube</label>
            <input formControlName="social_youtube" type="url" placeholder="https://youtube.com/@brand" class="form-control"
              [class.is-invalid]="urlError('social_youtube')" />
            <div *ngIf="urlError('social_youtube') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-tiktok me-1"></i> TikTok</label>
            <input formControlName="social_tiktok" type="url" placeholder="https://tiktok.com/@brand" class="form-control"
              [class.is-invalid]="urlError('social_tiktok')" />
            <div *ngIf="urlError('social_tiktok') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-snapchat me-1"></i> Snapchat</label>
            <input formControlName="social_snapchat" type="url" placeholder="https://snapchat.com/add/brand" class="form-control"
              [class.is-invalid]="urlError('social_snapchat')" />
            <div *ngIf="urlError('social_snapchat') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-4">
            <label class="form-label font-13 font-semibold text-secondary mb-1"><i class="fa-brands fa-linkedin me-1"></i> LinkedIn</label>
            <input formControlName="social_linkedin" type="url" placeholder="https://linkedin.com/company/brand" class="form-control"
              [class.is-invalid]="urlError('social_linkedin')" />
            <div *ngIf="urlError('social_linkedin') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
        </div>
      </div>

      <!-- Section 8: Legal & Defaults -->
      <div class="form-section-card mb-4">
        <div class="section-header mb-3">
          <span class="section-step-badge">8</span>
          <span class="section-title">Legal & Defaults</span>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Terms & Conditions URL</label>
            <input formControlName="terms_url" type="url" placeholder="https://brand.com/terms" class="form-control"
              [class.is-invalid]="urlError('terms_url')" />
            <div *ngIf="urlError('terms_url') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-6">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Privacy Policy URL</label>
            <input formControlName="privacy_url" type="url" placeholder="https://brand.com/privacy" class="form-control"
              [class.is-invalid]="urlError('privacy_url')" />
            <div *ngIf="urlError('privacy_url') as err" class="text-danger font-12 mt-1">{{ err }}</div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Default Theme</label>
            <nz-select formControlName="default_theme" class="w-100 custom-nz-select" [nzOptionOverflowSize]="5">
              <nz-option nzValue="system" nzLabel="Follow device"></nz-option>
              <nz-option nzValue="light" nzLabel="Forced Light"></nz-option>
              <nz-option nzValue="dark" nzLabel="Forced Dark"></nz-option>
            </nz-select>
            <div class="text-muted font-12 mt-1">
              {{ previewThemeForced ? 'Visitors always see this theme and cannot switch it.' : 'Visitors can switch between Light and Dark.' }}
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label font-13 font-semibold text-secondary mb-1">Default Language</label>
            <nz-select formControlName="default_language" class="w-100 custom-nz-select" [nzOptionOverflowSize]="5">
              <nz-option nzValue="en" nzLabel="English"></nz-option>
              <nz-option nzValue="ar" nzLabel="العربية"></nz-option>
            </nz-select>
          </div>
          <div class="col-md-6 d-flex align-items-end">
            <div class="form-check">
              <input formControlName="powered_by" type="checkbox" id="powered_by" class="form-check-input" />
              <label for="powered_by" class="form-check-label font-13 text-secondary">
                Show "Powered by" badge on the participant page
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 9: Brand Assets & Logos -->
      <div class="form-section-card mb-2">
        <div class="section-header mb-3">
          <span class="section-step-badge">9</span>
          <span class="section-title">Brand Logos & Icons</span>
        </div>
        <div class="row g-3">
          <!-- Logo Light -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.logo-url-light' | translate }}</label>
              <input type="file" #logoFileInput accept="image/*" (change)="onFileSelected($event, 'logo_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.logo_url; else logoLightUploadBox">
                <div class="asset-preview-box">
                  <img [src]="extractUrl(brandForm.value.logo_url)" alt="Logo Light" class="asset-img" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('logo_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('logo_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #logoLightUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('logo_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Logo (Light)</div>
                  <div class="dropzone-subtitle">Click to browse image</div>
                </div>
              </ng-template>

              <div *ngIf="assetErrors['logo_url'] as err" class="text-danger font-12 mt-1" role="alert">{{ err | translate }}</div>
            </div>
          </div>

          <!-- Logo Dark -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.logo-url-dark' | translate }}</label>
              <input type="file" #logoDarkFileInput accept="image/*" (change)="onFileSelected($event, 'logo_dark_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.logo_dark_url; else logoDarkUploadBox">
                <div class="asset-preview-box is-dark">
                  <img [src]="extractUrl(brandForm.value.logo_dark_url)" alt="Logo Dark" class="asset-img" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('logo_dark_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('logo_dark_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #logoDarkUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('logo_dark_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Logo (Dark)</div>
                  <div class="dropzone-subtitle">Click to browse image</div>
                </div>
              </ng-template>

              <div *ngIf="assetErrors['logo_dark_url'] as err" class="text-danger font-12 mt-1" role="alert">{{ err | translate }}</div>
            </div>
          </div>

          <!-- Favicon Icon -->
          <div class="col-12 col-md-4">
            <div class="asset-card-wrapper">
              <label class="asset-card-label">{{ 'branding.favicon-url' | translate }}</label>
              <input type="file" #iconFileInput accept="image/*" (change)="onFileSelected($event, 'icon_url')" class="d-none" />

              <ng-container *ngIf="brandForm.value.icon_url; else iconUploadBox">
                <div class="asset-preview-box">
                  <img [src]="extractUrl(brandForm.value.icon_url)" alt="Favicon" class="asset-img is-icon" />
                  <div class="asset-overlay">
                    <button type="button" class="btn-action-round replace-btn" (click)="triggerFileInput('icon_url')" title="Change Image">
                      <i class="fa-solid fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn-action-round remove-btn" (click)="clearAssetImage('icon_url', $event)" title="Delete Image">
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-template #iconUploadBox>
                <div class="asset-dropzone-box" (click)="triggerFileInput('icon_url')">
                  <div class="dropzone-icon-circle">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </div>
                  <div class="dropzone-title">Upload Favicon</div>
                  <div class="dropzone-subtitle">Square icon (PNG/ICO)</div>
                </div>
              </ng-template>

              <div *ngIf="assetErrors['icon_url'] as err" class="text-danger font-12 mt-1" role="alert">{{ err | translate }}</div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </ng-container>

  <ng-template #modalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2 w-100">
      <button type="button" class="btn-modal-cancel" (click)="isBrandModalVisible = false">
        {{ 'branding.cancel' | translate }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="isSavingBrand" (click)="saveBrand()">
        <span *ngIf="isSavingBrand" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingBrand" class="fa-solid fa-check me-2"></i>
        {{ editingBrand ? ('branding.update' | translate) : ('branding.ok' | translate) }}
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- DOMAIN MODAL (Add Domain) -->
<nz-modal [(nzVisible)]="isDomainModalVisible" [nzCentered]="true"
  [nzTitle]="(editingDomain ? 'branding.edit-domain-modal-title' : 'branding.add-domain-modal-title') | translate"
  [nzOkText]="(editingDomain ? 'branding.update' : 'branding.ok') | translate"
  [nzCancelText]="'branding.cancel' | translate" (nzOnCancel)="isDomainModalVisible = false" (nzOnOk)="saveDomain()"
  [nzOkLoading]="isSavingDomain" nzClassName="luqta-styled-modal">
  <ng-container *nzModalContent>
    <form [formGroup]="domainForm" class="space-y-3 text-sm">
      <div class="mb-3">
        <label class="form-label font-medium">{{ 'branding.domain-name' | translate }} *</label>
        <input formControlName="hostname" type="text" [placeholder]="'branding.domain-placeholder' | translate"
          class="form-control font-mono"
          [class.is-invalid]="domainForm.get('hostname')?.touched && domainForm.get('hostname')?.invalid" />
        <small class="text-danger d-block font-12"
          *ngIf="domainForm.get('hostname')?.touched && domainForm.get('hostname')?.hasError('required')">
          Domain name is required
        </small>
        <small class="text-danger d-block font-12"
          *ngIf="domainForm.get('hostname')?.touched && domainForm.get('hostname')?.hasError('pattern')">
          Enter a host name such as play.yourbrand.com
        </small>
        <small *ngIf="editingDomain" class="text-muted mt-1 d-block font-12">
          {{ 'branding.domain-hostname-readonly' | translate }}
        </small>
        <small *ngIf="!editingDomain" class="text-muted mt-1 d-block font-12">
          {{ 'branding.domain-hint-1' | translate }} <code>.luqta.io</code> or <code>.luqta.app</code> {{
          'branding.domain-hint-2' | translate }}
        </small>
      </div>

      <div class="mb-3">
        <label class="form-label font-medium d-block mb-1">{{ 'branding.attach-to-brand' | translate }} *</label>
        <nz-select formControlName="branding_id" [nzPlaceHolder]="'branding.select-brand-placeholder' | translate"
          nzShowSearch class="w-100" [nzOptionOverflowSize]="5">
          <nz-option *ngFor="let b of brands" [nzValue]="b.id" [nzLabel]="b.name"></nz-option>
        </nz-select>
        <small class="text-danger d-block font-12"
          *ngIf="domainForm.get('branding_id')?.touched && domainForm.get('branding_id')?.invalid">
          Choose the brand this domain serves
        </small>
      </div>

      <div class="form-check">
        <input formControlName="is_primary" type="checkbox" id="is_primary" class="form-check-input" />
        <label for="is_primary" class="form-check-label font-12">{{ 'branding.set-primary-domain' | translate }}</label>
      </div>

      <!--
        ZERO STORAGE — create only.
        The three warnings below are permanent consequences of this switch, so
        they are body copy in the form rather than a tooltip. An existing domain
        gets the read-only summary instead: the mode and the key can never be
        changed once the row exists.
      -->
      <div class="zero-storage-block">
        <div class="zero-storage-head">
          <label class="zero-storage-label" [attr.for]="editingDomain ? null : 'zero_storage'">
            <i class="fa-solid fa-lock" aria-hidden="true"></i>
            {{ 'branding.zero-storage' | translate }}
          </label>
          <nz-switch *ngIf="!editingDomain" id="zero_storage" formControlName="zero_storage"
            [attr.aria-label]="'branding.zero-storage' | translate"></nz-switch>
          <span *ngIf="editingDomain" class="zero-storage-state" [class.is-on]="editingDomain.zero_storage">
            {{ (editingDomain.zero_storage ? 'branding.zero-storage-on' : 'branding.zero-storage-off') | translate }}
          </span>
        </div>

        <p class="zero-storage-desc">{{ 'branding.zero-storage-desc' | translate }}</p>

        <!-- Read-only for an existing domain: neither field can be sent to domain/update. -->
        <ng-container *ngIf="editingDomain">
          <div *ngIf="editingDomain.zero_storage && editingDomain.zero_storage_key_hint" class="font-12 mb-2">
            <span class="text-muted">{{ 'branding.zero-storage-key-hint-label' | translate }}:</span>
            <code class="font-mono ms-1">{{ editingDomain.zero_storage_key_hint }}</code>
          </div>
          <div class="zero-storage-warning" role="note">
            {{ 'branding.zero-storage-read-only' | translate }}
          </div>
        </ng-container>

        <ng-container *ngIf="!editingDomain">
          <div *ngIf="domainForm.get('zero_storage')?.value" class="mb-3">
            <label for="zero_storage_key" class="form-label font-medium font-12">{{ 'branding.zero-storage-key' | translate }} *</label>
            <input id="zero_storage_key" formControlName="zero_storage_key" type="password" autocomplete="new-password"
              [placeholder]="'branding.zero-storage-key-placeholder' | translate" class="form-control font-mono"
              [class.is-invalid]="domainForm.get('zero_storage_key')?.touched && domainForm.get('zero_storage_key')?.invalid" />
            <small class="text-danger d-block font-12 mt-1"
              *ngIf="domainForm.get('zero_storage_key')?.touched && domainForm.get('zero_storage_key')?.invalid">
              {{ 'branding.zero-storage-key-required' | translate }}
            </small>
          </div>

          <div class="zero-storage-warning" role="note">
            <div class="zero-storage-warning-title">
              <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
              {{ 'branding.zero-storage-warning-title' | translate }}
            </div>
            <ul>
              <li>{{ 'branding.zero-storage-warning-permanent' | translate }}</li>
              <li>{{ 'branding.zero-storage-warning-unrecoverable' | translate }}</li>
              <li>{{ 'branding.zero-storage-warning-create-only' | translate }}</li>
            </ul>
          </div>
        </ng-container>
      </div>
    </form>
  </ng-container>
</nz-modal>

<!-- DNS SETUP MODAL -->
<nz-modal [(nzVisible)]="dnsModalVisible" [nzCentered]="true"
  [nzTitle]="'DNS Instructions for ' + selectedDnsSetup?.hostname" (nzOnCancel)="dnsModalVisible = false"
  [nzFooter]="null" nzClassName="luqta-styled-modal">
  <ng-container *nzModalContent>
    <div class="space-y-3 text-sm">
      <p class="text-muted">
        Add the following two DNS records at your domain registrar (GoDaddy, Cloudflare, Namecheap, etc.) to complete
        verification:
      </p>

      <div *ngIf="selectedDnsSetup?.dns?.cname" class="p-3 bg-light rounded border">
        <label class="font-bold text-muted uppercase d-block mb-1 font-12">CNAME Record</label>
        <div class="row font-mono font-12">
          <div class="col-6"><span class="text-muted">Host:</span> {{ selectedDnsSetup.dns.cname.name }}</div>
          <div class="col-6"><span class="text-muted">Target:</span> {{ selectedDnsSetup.dns.cname.value }}</div>
        </div>
      </div>

      <div *ngIf="selectedDnsSetup?.dns?.txt" class="p-3 bg-light rounded border">
        <label class="font-bold text-muted uppercase d-block mb-1 font-12">TXT Verification Record</label>
        <div class="font-mono font-12">
          <div><span class="text-muted">Name:</span> {{ selectedDnsSetup.dns.txt.name }}</div>
          <div class="d-flex justify-content-between align-items-center mt-1">
            <div><span class="text-muted">Value:</span> {{ selectedDnsSetup.dns.txt.value }}</div>
            <button (click)="copyToClipboard(selectedDnsSetup.dns.txt.value)"
              class="btn btn-link btn-sm p-0">Copy</button>
          </div>
        </div>
      </div>

      <div class="alert alert-warning font-12 m-0 mt-3">
        After setting DNS records, press "Verify DNS" in the domains list. DNS propagation can take up to 1 hour.
      </div>
    </div>
  </ng-container>
</nz-modal>

<!-- EDIT JSON MODAL -->
<nz-modal [(nzVisible)]="isJsonModalVisible" [nzCentered]="true" [nzWidth]="780"
  [nzTitle]="jsonModalTitleTpl" [nzFooter]="jsonModalFooterTpl"
  (nzOnCancel)="closeEditJsonModal()" nzClassName="luqta-styled-modal">
  <ng-template #jsonModalTitleTpl>
    <div class="d-flex align-items-center gap-2">
      <i class="fa-solid fa-code text-primary"></i>
      <span *ngIf="!isExampleJsonModal">{{ 'branding.edit-json-modal-title' | translate }}</span>
      <span *ngIf="isExampleJsonModal">Example Brand JSON Schema</span>
      <span *ngIf="jsonModalBrand && !isExampleJsonModal" class="badge bg-purple-soft text-purple ms-2 font-12">
        {{ jsonModalBrand.name }}
      </span>
      <span *ngIf="isExampleJsonModal" class="badge bg-purple-soft text-purple ms-2 font-12">
        Sample Template
      </span>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div class="json-modal-body">
      <!-- Hidden file input for uploading directly into editor -->
      <input #editJsonFileInput type="file" accept=".json,application/json" class="d-none" (change)="onEditJsonFileSelected($event)" />

      <div class="json-editor-container mb-3">
        <div class="json-editor-toolbar">
          <span class="json-editor-title">
            <i class="fa-regular fa-file-code me-1"></i> config.json
          </span>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <button type="button" class="btn-toolbar-action" (click)="triggerEditJsonFileInput()" title="Import JSON file into editor">
              <i class="fa-solid fa-upload"></i> {{ 'branding.upload-json' | translate }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="prettifyJson()" title="Format JSON">
              <i class="fa-solid fa-wand-magic-sparkles"></i> {{ 'branding.prettify-json' | translate }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="copyJsonToClipboard()" title="Copy JSON">
              <i class="fa-regular fa-copy"></i> {{ isCopied ? ('branding.copied' | translate) : ('branding.copy-json' | translate) }}
            </button>
            <button type="button" class="btn-toolbar-action" (click)="downloadJson()" title="Download JSON file">
              <i class="fa-solid fa-download"></i> {{ 'branding.download-json' | translate }}
            </button>
          </div>
        </div>
        <textarea [(ngModel)]="rawJsonString" class="json-textarea" spellcheck="false"
          [placeholder]="'branding.json-placeholder' | translate"></textarea>
      </div>

      <div *ngIf="jsonError" class="alert alert-danger font-12 d-flex align-items-center gap-2 mb-0 py-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ jsonError }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #jsonModalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2 flex-wrap">
      <button type="button" class="btn-modal-cancel" (click)="closeEditJsonModal()">
        {{ isExampleJsonModal ? 'Close' : ('branding.cancel' | translate) }}
      </button>
      <button *ngIf="isExampleJsonModal" type="button" class="btn-modal-secondary" (click)="copyJsonToClipboard()">
        <i class="fa-regular fa-copy me-2"></i>
        {{ isCopied ? 'Copied!' : 'Copy Example' }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="isSavingJson" (click)="saveBrandJson()">
        <span *ngIf="isSavingJson" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingJson" class="fa-solid fa-check me-2"></i>
        {{ isExampleJsonModal ? 'Create Brand from Template' : ('branding.save-json' | translate) }}
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- UPLOAD JSON MODAL -->
<nz-modal [(nzVisible)]="isUploadJsonModalVisible" [nzCentered]="true" [nzWidth]="640"
  [nzTitle]="uploadJsonModalTitleTpl" [nzFooter]="uploadJsonModalFooterTpl"
  (nzOnCancel)="closeUploadJsonModal()" nzClassName="luqta-styled-modal">
  <ng-template #uploadJsonModalTitleTpl>
    <div class="d-flex align-items-center gap-2">
      <i class="fa-solid fa-cloud-arrow-up text-primary"></i>
      <span>{{ 'branding.upload-json-modal-title' | translate }}</span>
      <span *ngIf="uploadJsonBrand" class="badge bg-purple-soft text-purple ms-2 font-12">
        {{ uploadJsonBrand.name }}
      </span>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <div class="upload-json-body space-y-3">
      <input #jsonFileInput type="file" accept=".json,application/json" class="d-none" (change)="onJsonFileSelected($event)" />

      <!-- Drag and drop zone -->
      <div *ngIf="!uploadedJsonFileName" class="json-dropzone-box" [class.dragover]="isDragging"
        (click)="triggerJsonFileInput()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDropJsonFile($event)">
        <div class="dropzone-icon">
          <i class="fa-solid fa-cloud-arrow-up"></i>
        </div>
        <h5 class="dropzone-title">{{ 'branding.json-upload-dropzone' | translate }}</h5>
        <p class="dropzone-desc mb-0">{{ 'branding.json-upload-hint' | translate }}</p>
      </div>

      <!-- Uploaded file summary card -->
      <div *ngIf="uploadedJsonFileName" class="uploaded-file-card mb-3">
        <div class="file-meta">
          <i class="fa-solid fa-file-circle-check"></i>
          <div>
            <div class="file-name">{{ uploadedJsonFileName }}</div>
            <div class="file-status text-success font-12">Valid JSON parsed successfully</div>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-link text-danger p-0" (click)="clearUploadedJsonFile()" title="Remove file">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>

      <!-- Preview code box if file loaded -->
      <div *ngIf="uploadedJsonData" class="json-editor-container mb-3">
        <div class="json-editor-toolbar">
          <span class="json-editor-title">
            <i class="fa-solid fa-eye me-1"></i> Preview: {{ uploadedJsonFileName }}
          </span>
        </div>
        <textarea [value]="uploadedJsonData | json" class="json-textarea" style="height: 180px;" readonly></textarea>
      </div>

      <!-- Error message -->
      <div *ngIf="uploadJsonError" class="alert alert-danger font-12 d-flex align-items-center gap-2 mb-0 py-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ uploadJsonError }}</span>
      </div>
    </div>
  </ng-container>

  <ng-template #uploadJsonModalFooterTpl>
    <div class="d-flex align-items-center justify-content-end gap-2">
      <button type="button" class="btn-modal-cancel" (click)="closeUploadJsonModal()">
        {{ 'branding.cancel' | translate }}
      </button>
      <button type="button" class="btn-modal-submit" [disabled]="!uploadedJsonData || isSavingUploadJson" (click)="saveUploadedJson()">
        <span *ngIf="isSavingUploadJson" class="spinner-border spinner-border-sm me-2"></span>
        <i *ngIf="!isSavingUploadJson" class="fa-solid fa-check me-2"></i>
        {{ 'branding.apply-json' | translate }}
      </button>
    </div>
  </ng-template>
</nz-modal>